<template>
<div>
  Sales
</div>
</template>

<script>
import InputField from '@plugins/text-field/input-field'
import Dropdown from '@plugins/dropdown/dropdown';
import NTable from "@/plugins/datatable/datatable";
import {mapActions, mapGetters, mapMutations} from 'vuex';
import * as suppliersActionTypes from '../../store/suppliers/types';
import {DistributionStoreNamespace as storeNS } from '../../store';
import { createNTableConfig } from '../../../../plugins/datatable';
import { Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { ConfirmationService } from '../../../../dt-plugins/confirmation/confirmation.service';
import { accountListRoute,accountDetailsRoute,accountDetailsTabRoute,accountDetailsSelectable,SelectResults } from '../../router/index';
import Sidewindow from '../../../../dt-plugins/sidewindow/sidewindow';
import { childOfOrEqual } from '../../../../router/functions';
import SalesSideWindow from '../../components/sales/sales.sidewindow.vue';
  export default {
    components: {
    InputField,
    NTable,
    SalesSideWindow,
    Sidewindow
    
  },
      data(){
          return{          
          accountTableConfig: createNTableConfig({
            scrollNextThreshold: 95,
          }),
              channels:[{text:"Physical",value:"physical"},{text:"Digital",value:"digital"}],
              searchString: '',
              searchSubject$: new Subject(),
              selectedChannel:null,
               selectedClickedAccount: null,
               sales:[]
     
          }
          

      },
  
    computed: {
      ...mapGetters(storeNS, {
    

    }),
    
     accountDetailsFlag: function() {
     // return childOfOrEqual(accountDetailsRoute)(this.$route.name);
    },
     headers: function() {
      return [
        { value: 'account_name' , text: this.$t('Account'   )},
        { value: 'short_name'   , text: this.$t('Short Name'   )},
        { value: 'account_type' , text: this.$t('Account Type')},
        { value: 'digital'      , text: this.$t('Digital') },
        { value: 'physical'     , text: this.$t('Physical') },
         { value: 'options'          , text:         ''              },
        
      ];
    },
    },
    mounted: function() {
  //  this[AccountActionTypes.AccountData.FETCH.ALL]();

    this.$subscribeTo(
      this.searchSubject$
      .asObservable()
      .pipe(
        distinctUntilChanged(), 
        debounceTime(350)
      ),
      searchString => {
       // this[AccountActionTypes.SEARCH_ACCOUNT](searchString);
      }
    )
     },

     watch: {
    '$route': {
      immediate: true,
      handler: function(to, from) {

        const {selectResult,accountId } = accountDetailsSelectable(to, from);

        switch(selectResult) {
          case SelectResults.SELECT: {
            this.selectAccount(accountId);
            break;
          }
          case SelectResults.SELECT_AUTO: {
            this.selectAccountAuto(accountId);
            break;
          }
          case SelectResults.CLOSE: {
            this.closeAccountDetails();
            break;
          }
          case SelectResults.IGNORE: {

            break;
          }
        }

        console.log(selectResult);

      }
    }
  },

    created () {
     
    },

    methods: {
    //    ...mapActions(storeNS, {
    //   [AccountActionTypes.AccountData.FETCH.ALL]: AccountActionTypes.AccountData.FETCH.ALL,
    //   [AccountActionTypes.SEARCH_ACCOUNT]: AccountActionTypes.SEARCH_ACCOUNT,
    //   [AccountActionTypes.FILTER_ACCOUNT_BY_CHANNEL]: AccountActionTypes.FILTER_ACCOUNT_BY_CHANNEL,
    //   [AccountActionTypes.DELETE_ACCOUNT]: AccountActionTypes.DELETE_ACCOUNT,
    //   [AccountActionTypes.SET_ACCOUNT_DETAILS]: AccountActionTypes.SET_ACCOUNT_DETAILS,
     
    // }),
    onAccountTableScrollNext: function(percent) {
     
    },
        onAddAccountClick: function() {
      console.log('onAddAccountClick');
      this.$router.push({
        ...this.$route,
        query: {
          modal: 'add_account'
        }
      });
    },
      onSearchInputKeyup(){
      this.searchString = event.target.value;
      this.selectedChannel = null;
      console.log('Searchstring Set', this.searchString);
      this.searchSubject$.next(this.searchString);
      },
      selectedRow:function(account) {
      return this.selectedClickedAccount && this.selectedClickedAccount['account_id'] === account['account_id'];
    },
      onRowClicked: function(account) {
      this.selectedClickedAccount = account;
      this.$router.push({
        name: accountDetailsTabRoute,
        params: {
          account_id: account.account_id,
          tab: this.$route.params.tab ? this.$route.params.tab : 'overview'
        }
      });
    },
      deleteAccount(account){
        ConfirmationService.create({
        subject: `Do you really want to delete the account "${account.account_name}" ?`,
        model: true,
        width: 500,
        completed: res => {
          switch(res) {
            case 'OK': {
              // this[AccountActionTypes.DELETE_ACCOUNT]({
              //   accountId: account.account_id
              // });
              break;
            }
          }
        }
      });
      },
      onChannelSelected(value){
      this.searchString = '';
      this.selectedChannel = value;
      // this[AccountActionTypes.FILTER_ACCOUNT_BY_CHANNEL]({
      //   channel: this.selectedChannel && this.selectedChannel.value
      // });
      },
     onCloseAccountSidewindow: function() {
      this.selectedClickedAccount = null;
      this.closeAccountDetails();
      if (this.$route.query && this.$route.query.from) {
        this.$router.push({
          ...decode(this.$route.query.from)
        });
      } else {
        this.$router.push({
          name: 'accountListRoute',
        });
      }
    },

    selectAccount: function(accountId) {
      const selectedAccount = this.accounts.find(account => account.account_id === accountId);
      // this[AccountActionTypes.SET_ACCOUNT_DETAILS]({flag: true, account: selectedAccount});
      // this.$store.commit(`${storeNS}/${AccountActionTypes.SELECTED_ACCOUNT.SET.SINGLE}`, selectedAccount);
    },
    selectAccountAuto: function(account_id) {
     // this[AccountActionTypes.SET_ACCOUNT_DETAILS]({flag: true, account: { account_id }});
      this.selectedClickedAccount = { account_id };
       
    },
    closeAccountDetails: function() {
      //this[AccountActionTypes.SET_ACCOUNT_DETAILS]({flag: false});
    },
    }
  }
</script>

<style lang="scss">



  .cmp-account-list {
    .dt-ntable.account-list {

     --ntable-height: calc(100vh - 135px);
       @media (min-width: 320px) and (max-width: 480px) {
        
        th:nth-child(2),
        td:nth-child(2),
        th:nth-child(3),
        td:nth-child(3),
        th:nth-child(4),
        td:nth-child(4),
        th:nth-child(7),
        td:nth-child(7)
        {
          display: none;
        }
  
      }
      td.physical,td.digital{
        .accent--text {
            color: #1d67e2 !important;
          }
      }
      td.account_name {
        font-weight: 800 !important;
      }
      td.options {
        .option-buttons {
          display: flex;
          justify-content: flex-end;
        }
      }

      th:nth-child(7),
      td:nth-child(7) {
        flex: 0.5;
      }
    }
    .account-top-bar {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      
      &>div {
        margin: 0px 10px;
      }

      .add-button {
        flex: 0.4;
        padding: 5px;
        display: flex;
        justify-content: center;
      }
      .search {
        flex: 2;
      }
      .users-dropdown {
        flex: 2;
      }
      .right-space {
        flex: 8;
      }

      .dropdown {
        flex: 5;
        max-width: 127px;
        margin: 0px 10px;

      
      }
    }
  }


 
</style>